import moment from 'moment-timezone';
import React, { useState } from 'react';
import styled from 'styled-components';

interface DatePickerProps {
  date: Date;
  setDate: (date: Date) => void;
}

const DatePicker = ({ date, setDate }: DatePickerProps) => {
  const [status, setStatus] = useState<number>(0);

  const addDate = () => {
    if (moment(new Date()).startOf('day').isAfter(moment(date).startOf('day'))) {
      const nextDate = moment(date).add(1, 'days');
      setDate(nextDate.toDate());
    }
  };

  const subtractDate = () => {
    const prevDate = moment(date).subtract(1, 'days');
    setDate(prevDate.toDate());
  };

  return (
    <Style>
      <div className="dateWrap">
        <div className="dateButton">
          <button
            // className="left"
            onClick={subtractDate}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left_black.svg`} alt="left" />
          </button>
          <div className="date">
            <h3>{moment(date).format('MM/DD')}</h3>
          </div>
          <button
            // className={`right ${
            //   moment(date).startOf('day').isSameOrAfter(moment(new Date()).startOf('day')) &&
            //   'inactive'
            // }`}
            onClick={addDate}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right_${
                moment(date).startOf('day').isSameOrAfter(moment(new Date()).startOf('day'))
                  ? 'grey'
                  : 'black'
              }.svg`}
              alt="left"
            />
          </button>
        </div>
      </div>
    </Style>
  );
};

export default DatePicker;

const Style = styled.div`
  .dateWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .dateButton {
      display: flex;
      align-items: center;
      padding: 4px 10px;
      background: #f7f7f7;
      border-radius: 50px;

      img {
        height: 24px;
      }
    }

    button {
      display: flex;
      align-items: center;
      padding: 0;
      /* background: #555555;
      border: 1px solid #555555; */
      /* border-radius: 50px; */
    }
    .date {
      width: 80px;
      padding: 4px 0;
      text-align: center;
      h3 {
        line-height: 20px;
        color: #555555;
        font-weight: 500;
      }
    }

    /* button.left {
      border-radius: 5px 0 0 5px;
    }
    button.right {
      border-radius: 0 5px 5px 0;
    } */
    button.inactive {
      background: #d9d9d9;
      border: 1px solid #d9d9d9;
    }
  }
`;
